import * as Mod1 from "./discourse/components/modal/math-edit";
import * as Mod2 from "./discourse/components/modal/math-insert";
import * as Mod3 from "./discourse/initializers/math-admin-plugin-configuration-nav";
import * as Mod4 from "./initializers/discourse-math-rich-editor";
import * as Mod5 from "./initializers/discourse-math";
import * as Mod6 from "./lib/discourse-markdown/discourse-math";
import * as Mod7 from "./lib/katex-bundle";
import * as Mod8 from "./lib/load-katex";
import * as Mod9 from "./lib/load-mathjax";
import * as Mod10 from "./lib/math-bundle-paths";
import * as Mod11 from "./lib/math-renderer";
import * as Mod12 from "./lib/mathjax-bundle";
import * as Mod13 from "./lib/rich-editor-extension";
const compatModules = {
  "discourse/components/modal/math-edit": Mod1,
  "discourse/components/modal/math-insert": Mod2,
  "discourse/initializers/math-admin-plugin-configuration-nav": Mod3,
  "initializers/discourse-math-rich-editor": Mod4,
  "initializers/discourse-math": Mod5,
  "lib/discourse-markdown/discourse-math": Mod6,
  "lib/katex-bundle": Mod7,
  "lib/load-katex": Mod8,
  "lib/load-mathjax": Mod9,
  "lib/math-bundle-paths": Mod10,
  "lib/math-renderer": Mod11,
  "lib/mathjax-bundle": Mod12,
  "lib/rich-editor-extension": Mod13,
};
export default compatModules;
